module.exports = __webpack_public_path__ + "img/fashion_79.ca5511bb.jpg";